module.exports = __webpack_public_path__ + "img/logo_black.2e72dc62.png";